import { Flex } from '@chakra-ui/react';
import { Button } from '@mesh.ai/rabbit';
import { useQueryClient } from '@tanstack/react-query';
import { useToast } from 'components/hooks/useToast';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { acknowledgeNudgeCard } from '../dataHooks';
import { handleActionClick } from '../helpers/nudgeActionHelpers';
import type { UITemplate } from '../types/nudgeCard';

type TeamPromotionAcknowledgeButtonProps = {
  ecaId: number;
  nudgeId: number;
  buttonText: string;
  uiTemplate: UITemplate;
};

export const TeamPromotionAcknowledgeButton = ({
  ecaId,
  nudgeId,
  buttonText,
  uiTemplate,
}: TeamPromotionAcknowledgeButtonProps) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const handleAcknowledge = async () => {
    try {
      await acknowledgeNudgeCard({ nudgeId });
      queryClient.invalidateQueries([REACT_QUERY_KEYS.meshRecommends.nudgeCards, 'HOME_PAGE']);
    } catch {
      toast({ title: 'Error acknowledging nudge', status: 'error' });
    }
  };

  return (
    <Flex justifyContent="end" w="full" pr="1.7rem">
      <Button variant="outline" onClick={() => handleActionClick({ ecaId, uiTemplate, action: handleAcknowledge })}>
        {buttonText}
      </Button>
    </Flex>
  );
};
